// SPDX-FileCopyrightText: 2023 TRUMPF Laser SE
//
// SPDX-License-Identifier: LicenseRef-TRUMPF
import type { IconProps } from '@tls/treact-ui/icons';
import React from 'react';

const IconEvaluation = ({ id, width, height, viewBox, strokeWidth, stroke, fill, ...other }: IconProps) => {
  return (
    <svg
      id={id ?? 'svg-evaluation'}
      data-name='svg-evaluation'
      data-testid='svg-evaluation'
      xmlns='http://www.w3.org/2000/svg'
      width={width ?? '30'}
      height={height ?? '30'}
      viewBox={viewBox ?? '0 0 30 30'}
      strokeWidth={strokeWidth ?? '0'}
      stroke={stroke ?? 'currentColor'}
      fill={fill ?? 'currentColor'}
      {...other}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.16117 23.8388C5.11092 22.7886 4.80962 21.1866 5.13899 19.0846C3.41975 17.8311 2.5 16.4853 2.5 15C2.5 13.5147 3.41975 12.1689 5.13899 10.9154C4.80962 8.81343 5.11092 7.21141 6.16117 6.16117C7.21141 5.11092 8.81343 4.80962 10.9154 5.13899C12.1689 3.41975 13.5147 2.5 15 2.5C16.4853 2.5 17.8311 3.41975 19.0846 5.13899C21.1866 4.80962 22.7886 5.11092 23.8388 6.16117C24.8891 7.21141 25.1904 8.81343 24.861 10.9154C26.5803 12.1689 27.5 13.5147 27.5 15C27.5 16.4853 26.5803 17.8311 24.861 19.0846C25.1904 21.1866 24.8891 22.7886 23.8388 23.8388C22.7886 24.8891 21.1866 25.1904 19.0846 24.861C17.8311 26.5803 16.4853 27.5 15 27.5C13.5147 27.5 12.1689 26.5803 10.9154 24.861C8.81343 25.1904 7.21141 24.8891 6.16117 23.8388ZM13.8636 15.6657L18.7419 10.7874L20.349 12.3944L13.8636 18.8798L9.65101 14.6672L11.2581 13.0601L12.5609 14.3629L13.8636 15.6657Z'
        fill='black'
      />
    </svg>
  );
};

export default IconEvaluation;
